module.exports = {"500102006":"敦仁街道","500102007":"崇义街道","500102008":"荔枝街道","500102009":"江北街道","500102010":"江东街道","500102011":"李渡街道","500102012":"龙桥街道","500102013":"白涛街道","500102014":"马鞍街道","500102103":"南沱镇","500102107":"青羊镇","500102118":"百胜镇","500102119":"珍溪镇","500102120":"清溪镇","500102121":"焦石镇","500102122":"马武镇","500102123":"龙潭镇","500102124":"蔺市镇","500102125":"新妙镇","500102126":"石沱镇","500102127":"义和镇","500102204":"罗云乡","500102206":"大木乡","500102208":"武陵山乡","500102216":"大顺乡","500102217":"增福乡","500102222":"同乐乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/500102.json
// module id = 2213
// module chunks = 0